import { createSlice } from "@reduxjs/toolkit";

const toastSlice = createSlice({
  name: "toast",
  initialState: {
    open: false,
    content: {},
  },
  reducers: {
    openToast: (state, action) => {
      state.open = true;
      state.content = action.payload;
    },
    closeToast: (state) => {
      state.open = false;
      state.content = {};
    },
  },
});

export const selectStateToast = (state: any) =>
  state.trackingApp.toast;

export const { openToast, closeToast } = toastSlice.actions;

export default toastSlice.reducer;
